import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';


const Message = ({ 
    title = "Éxito", 
    content = "Operación realizada correctamente.", 
    open = false,
    onClose  // Nueva prop: función para notificar al padre cuando se cierra
}) => {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    // Maneja el cierre localmente y notifica al padre
    const handleClose = () => {
        if (onClose) onClose(); // Importante: avisar al padre
    };

    return (
        <Dialog
            open={open}  // Controlado completamente por el padre
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    {t("ui.okButton")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Message;